import { render, staticRenderFns } from "./Muhurtas.vue?vue&type=template&id=ee5512b6&"
import script from "./Muhurtas.vue?vue&type=script&lang=js&"
export * from "./Muhurtas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Muhurtas.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports